import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exemption',
  templateUrl: './exemption.component.html',
  styleUrls: ['./exemption.component.css']
})
export class ExemptionComponent implements OnInit {
  month:any;
  reasonType:any;
  notes:any;
  noteSize:any=0;

  constructor() { }

  ngOnInit() {
  }
  onQuickTextChanged(event) {
    this.noteSize = this.notes.length;
  }

}



// WEBPACK FOOTER //
// ./src/app/exemption/exemption.component.ts